export const GENESIS_API_BASE_URL = "https://dev.api.genflooring.com";
export const SUPPORT_EMAIL = "kkoh@genesisfloor.net";
export const GENESIS_LOGO_COLOR = "#002466";
export const GENESIS_LOGO_SECONDARY_COLOR = "#001843";
export const DARK_THEME_APP_BAR_COLOR = "#000000";
export const DARK_THEME_PAPER_COLOR = "#181818";
export const DARK_THEME_BODY_COLOR = "#252525";
export const DARK_THEME_TEXT_COLOR = "#ECECEC";
export const DARK_THEME_INPUT_OUTLINE_COLOR = "#636363";
export const DARK_THEME_DISABLED_TEXT_COLOR = "#959595";
export const DARK_THEME_DISABLED_BUTTON_BG_COLOR = "#494949";
export const DARK_THEME_DISABLED_BUTTON_TEXT_COLOR = "#252525";
export const LIGHT_THEME_PAPER_COLOR = "#FFFFFF";
export const LIGHT_THEME_BODY_COLOR = "#FAFAFA";
export const LIGHT_THEME_TEXT_COLOR = "black";
export const LIGHT_THEME_INPUT_OUTLINE_COLOR = "#0000001f";
export const LIGHT_THEME_DISABLED_TEXT_COLOR = "#00000061";
export const LG_HEADER_HEIGHT = "64px";
export const SM_HEADER_HEIGHT = "56px";
export const WINDOW_TRANSITION_WIDTH_HEADER_INT = 600;
export const LG_DRAWER_WIDTH = 180;
export const SM_DRAWER_WIDTH = 65;
export const MUI_LICENSE_KEY =
  "19ca6312b1af874c6816d71b7571c26eTz0xMzE2MTAsRT0xODE3MDc4Mzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=";
export const SUPPORTED_COMPRESSED_FILE_TYPES = ["zip"];
export const SUPPORTED_DOC_FILE_TYPES = [
  "xls",
  "xlsm",
  "xlsx",
  "ppt",
  "pptx",
  "doc",
  "docx",
  "pdf",
  "txt",
  "csv",
];
export const SUPPORTED_IMG_FILE_TYPES = ["jpg", "jpeg", "png", "gif"];
export const SUPPORTED_PREVIEW_FILE_TYPES = SUPPORTED_DOC_FILE_TYPES.concat(
  SUPPORTED_IMG_FILE_TYPES,
);
export const SUPPORTED_UPLOAD_FILE_TYPES = SUPPORTED_DOC_FILE_TYPES.concat(
  SUPPORTED_IMG_FILE_TYPES,
)
  .concat(SUPPORTED_COMPRESSED_FILE_TYPES)
  .concat(["heic"])
  .map((type) => "." + type)
  .join(",");
export const PROJECT_STATUSES = [
  "Archive",
  "Proposal Generation",
  "Proposal Completed",
  "Proposal Sent",
  "PO Received",
  "Schedule Install & Order Materials",
  "Awaiting Installation",
  "Invoice",
  "Awaiting Payment",
  "Job Complete",
];
export const MAX_UPLOAD_SIZE_MB = 200;
export const MAX_UPLOAD_SIZE = MAX_UPLOAD_SIZE_MB * 1024 * 1024;
export const MAX_NUM_FILES = 50;
export const CMAS_TYPES = [
  "Genesis-4-25-05-1052",
  "Genesis GSA",
  "Tarkett-4-24-04-1042",
  "Tarkett Sourcewell-061323-TFU",
  "Shaw-4-24-11-1022",
  "Shaw Turf-4-22-07-1024",
  "CUPCCAA",
  "FCCC-00011717",
];
